import { css } from '@emotion/react'

export const wrapper = css`
  margin-bottom: 4rem;
`

export const form = css`
  margin: 0 auto;
`
